<script lang="ts">
  import 'plyr/dist/plyr.css';
  import { createEventDispatcher, onDestroy, onMount } from 'svelte';
  export let poster: string | null = null;
  export let source: string[] = [];
  export let muted: boolean = false;
  export let loop: boolean = false;
  export let controls: boolean = true;

  let videoEl: HTMLVideoElement;
  let player: any = null;
  const dispatch = createEventDispatcher();

  async function setupPlyr() {
    try {
      const mod: any = await import('plyr');
      const Plyr = mod && (mod.default || mod);
      if (!Plyr) return;

      player = new Plyr(videoEl, {
        controls: controls ? ['play', 'progress', 'current-time', 'mute', 'volume', 'fullscreen'] : [],
        clickToPlay: true,
        hideControls: false,
        keyboard: { global: false },
      });

      // forward events
      player.on('play', () => dispatch('play'));
      player.on('pause', () => dispatch('pause'));
      player.on('ended', () => dispatch('ended'));
    } catch (e) {
      // plyr not available; fallback to native video element (do nothing)
      console.error(e);
    }
  }

  onMount(() => {
    // ensure playsinline attributes for iOS
    if (videoEl) {
      videoEl.setAttribute('playsinline', '');
      videoEl.setAttribute('webkit-playsinline', '');
      if (muted) videoEl.muted = true;
    }
    setupPlyr();
  });

  onDestroy(() => {
    try {
      if (player && typeof player.destroy === 'function') player.destroy();
      if (videoEl) {
        videoEl.pause();
        videoEl.removeAttribute('src');
        videoEl.load();
      }
    } catch (e) {
      // ignore
      console.error(e);
    }
  });
</script>

<div class="plyr-container">
  <video
    bind:this={videoEl}
    class="plyr-video"
    {poster}
    {muted}
    {loop}
    {controls}
    preload="metadata"
    playsinline
    webkit-playsinline
  >
    {#if source && source.length}
      {#each source as src}
        {#if src.includes('mp4')}
          <source {src} type="video/mp4" />
        {:else if src.includes('webm')}
          <source {src} type="video/webm" />
        {:else}
          <source {src} />
        {/if}
      {/each}
    {/if}
  </video>
</div>

<style>
  .plyr-video {
    width: 100%;
    height: 100%;
    background: black;
    max-height: 100%;
    object-fit: contain;
  }
</style>
